
export const all = (state) => {
	return state.activities
}

export const main = (state) => {
	return state.activities.filter(activity => !activity.parent)
}

export const byParent = (state) => (parent) => state.activities.filter(activity => activity.parent === parent)

export const byId = (state) => (id) => {
	return state.activities.find(activity => activity.activityId === id)
}

export const next = (state) => (id) => {
	return state.activities.find(activity => {
		return (activity.afterOf === id && (activity.url || activity.evaluation))
	})
}
